import { ToolOutlined } from "@ant-design/icons";
import { Button } from "antd";
import styled from "styled-components";

export const StyledConfirmButton = styled(Button)`
    width: 100%;
    margin-top: 16px;
    background-color: ${(props) =>
        props.theme.additionalTypographyColor} !important;
    border-radius: 50px !important;

    height: 50px !important;
`;

export const StyledToolIcon = styled(ToolOutlined)`
    font-size: 20px;
`;
